/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
// import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { Formik } from "formik";
import * as Yup from "yup";
// import aboutImage from "/public/assets/images/about-img.jpg";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { contactUs } from "../store/actions/contactUs";

// import { getContactUsData } from "../store/actions/contactUsAction";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

const schema = Yup.object().shape({
  // parameter: Yup.string().required("Un filtre à ajouter ? is a required field"),
  email: Yup.string()
    .required("Mot de passe nécessaire")
    .email("Invalid email format"),
  comments: Yup.string()
    .required("Comments or Parameter is a required field")
    // .min(8, "Comments must be at least 8 characters"),
});

const contactus = (props) => {
  const size = useWindowSize();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getContactUsData());
  // }, [dispatch]);
  // const contactusData = useSelector((state) => state.contactUsInfo.contactUsInfo.data);
  // console.log(contactusData,'Props +++')
  return (
    <div className="MapContent navbartopmargin bg"
    style={{ minHeight: size.height }}>
      <Head>
        <title>Residen | Nous contacter</title>
      </Head>
      <Header />
      <div className="container pt-4 pb-4">
        <div className="height d-flex justify-content-center align-items-center">
          <div className="form-main-box justify-content-center">
          <h3 style={{ textAlign: 'center',color: 'orange'}}>Nous contacter</h3>
          <hr style={{ borderTop: "4px solid #000 ", marginLeft: 20, marginRight: 20, borderRadius:30 }}></hr>
            <Formik
              validationSchema={schema}
              initialValues={{
                email: "",
                parameter: "",
                comments: "",
              }}
              validate={(values) => {
                const errors = {};
                return errors;
              }}
              enableReinitialize
              onSubmit={(values) => {
                const { email, parameter, comments } = values;
                dispatch(
                  contactUs({values})
                );
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label style={{color:'orange'}}>Ton email.</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      className="form-control"
                      placeholder="Ecrit ici ..."
                      style={{border: "2px solid 	#FFA500 "}}
                    />
                    <span className="error text-danger">
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  <div className="mb-4">
                    <label style={{color:'orange'}}>Un filtre à ajouter ?</label>
                    <input
                      type="text"
                      name="parameter"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.parameter}
                      className="form-control"
                      placeholder="Ecrit ici ..."
                      style={{border: "2px solid 	#FFA500 "}}
                    />
                    {/* <span className="error text-danger">
                      {errors.parameter && touched.parameter && errors.parameter}
                    </span> */}
                  </div>
                  <div className="mb-4">
                    <label style={{color:'orange'}}>Pour les commentaires ou questions :</label>
                    <input
                      type=""
                      name="comments"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.comments}
                      className="form-control"
                      placeholder="Ecrit ici ..."
                      style={{border: "2px solid 	#FFA500 ", height:90}}
                    />
                    <span className="error text-danger">
                      {errors.comments && touched.comments && errors.comments}
                    </span>
                  </div>
                  <div className="input-group">
                    <button
                      className="btn frm-btn-cmn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Envoyer
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default contactus;
